import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DemoPage } from '../features/demo/demo.page';
export var __N_SSP = true;
export default function DemoRoute() {
  return _jsx(DemoPage, {});
}